import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getMemos,
  getProject,
  getProjects,
  getTimezones,
  saveProfile,
  saveProject,
  saveProjectArea,
  sendMessage,
} from '@/app/account/api/endpoints.ts';
import { useNotifications } from '@/hooks/use-notifications.ts';
import { router } from '@/router/router.tsx';

export function useGetMemosQuery(params?: any) {
  return useQuery({
    queryFn: () => getMemos(params),
    queryKey: ['memos', params],
  });
}

export function useGetProjectsQuery(params?: any) {
  return useQuery({
    queryFn: () => getProjects(params),
    queryKey: ['projects', params],
  });
}

export function getProjectQuery(id: number | string) {
  return {
    queryFn: () => getProject(id as any),
    queryKey: ['projects', String(id)],
  };
}

export function useProjectSaveMutation() {
  const { mutateProps, showSuccess } = useNotifications();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => saveProject(data),
    ...mutateProps,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['projects'], refetchType: 'all' });
      await router.invalidate();
      showSuccess('Project saved successfully');
    },
  });
}

export function useSaveProjectAreaMutation() {
  const { mutateProps, showSuccess } = useNotifications();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => saveProjectArea(data),
    ...mutateProps,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['projects'], refetchType: 'all' });
      await router.invalidate();
      showSuccess('Project area saved successfully');
    },
  });
}

export function useSendMessageMutation() {
  const { mutateProps, showSuccess } = useNotifications();
  return useMutation({
    mutationFn: (data: any) => sendMessage(data),
    ...mutateProps,
    onSuccess: () => {
      showSuccess('Message sent successfully');
    },
  });
}

export function useGetTimezonesQuery() {
  return useQuery({
    queryFn: () => getTimezones(),
    queryKey: ['timezones'],
  });
}

export function useSaveProfileMutation() {
  const { mutateProps, showSuccess } = useNotifications();
  return useMutation({
    mutationFn: (data: any) => saveProfile(data),
    ...mutateProps,
    onSuccess: async () => {
      showSuccess('Profile saved successfully');
    },
  });
}
